// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-submit-tips-portrait{z-index:10001;position:fixed;top:0;left:0;bottom:0;right:0;background-color:rgba(0,0,0,.3)}.plv-iar-submit-tips-portrait__main{width:320px;height:320px;position:absolute;left:50%;top:40%;transform:translate(-50%, -40%);background-size:contain;background-position:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
